import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Constants } from "../../Common/Constants";
// import { fetchWorkoutAnalytics } from "../../../Redux/Actions";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import ExcelIcon from "../../../assets/images/excel.png";
import Spinner from "../../../assets/images/Spinner.gif";
import { getWorkoutSessionSplitMinutesReportAction } from "../../../Redux/Actions/WorkoutAnalyticsActions";
import ReactSelect from "../../Common/Fields/ReactSelect";
import usePermissions from "../../Common/Functions/usePermissions";
import TabsBootstrap from "../../Common/UiModel/TabsBootstrap";
import Monthly from "./Monthly";
import Quarterly from "./Quarterly";
import Weekly from "./Weekly";
import Yearly from "./Yearly";


const WorkoutSessionSplit = () => {
  const workoutSessionSplit = useSelector((store) => store.WorkOutAnalyticsReportReducer.workoutSessionSplitMinutes.count);
  // const sumOfWorkoutSessionSplit = sumOfRecordCounts(workoutSessionSplit);


  const tabsList = [
    {
      eventKey: Constants.analyticsWeek,
      title: Constants.analyticsSevenDays,
      component: <Weekly />,
    },
    {
      eventKey: Constants.analyticsMonth,
      title: Constants.analyticsThirtyDays,
      component: <Monthly />,
    },
    {
      eventKey: Constants.analyticsThreeMonths,
      title: Constants.analyticsNinetyDays,
      component: <Quarterly />,
    },
    {
      eventKey: Constants.analyticsYear,
      title: Constants.analyticsOneYear,
      component: <Yearly />,
    },
  ];
  const [activetab, setActiveTab] = useState(tabsList?.[0]?.eventKey);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedMode, setSelectedMode] = useState(Constants.modeOptions?.[0]);
  const [selectedGender, setSelectedGender] = useState(
    Constants.genderOptions?.[0]
  );
  const [loader, setLoader] = useState(false);
  // Permissions
  const viewPermission = usePermissions(
    Constants.permission.DOWNLOAD_REPORT_VIEW
  );

  useEffect(() => {
    // const data = {
    //   days: activetab,
    //   mode: selectedMode.value,
    //   gender: selectedGender.value,
    // };
    // dispatch(fetchWorkoutAnalytics(data));

    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const formattedDate = tomorrow.toISOString().split("T")[0];


    //  const formattedDate = today.toISOString().split("T")[0];
    const data2 = {
      noofdays: activetab,
      gender: selectedGender.value,
      currentDate: formattedDate,
      mode: selectedMode.value,
    };

    dispatch(getWorkoutSessionSplitMinutesReportAction(data2));
  }, [activetab, selectedMode, selectedGender]);

  useEffect(() => {
    // Set active tab as per URL
    const queryParams = new URLSearchParams(location.search);
    const tabParam = queryParams.get(Constants.activeTab);
    if (tabParam && tabsList.map((elt) => elt.eventKey).includes(tabParam)) {
      setActiveTab(tabParam);
    }
  }, [location]);

  const handleTabSelect = (key) => {
    // Set URL in correspondance with active tab
    setActiveTab(key);
    const queryParams = new URLSearchParams(location.search);
    queryParams.set(Constants.activeTab, key);
    navigate(`?${queryParams.toString()}`);
  };

  // const onExportExcel = async () => {
  //   const data = {
  //     days: activetab,
  //     mode: selectedMode.value,
  //     gender: selectedGender.value,
  //   };
  //   setLoader(true);
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_URL}${ApiUrl.WORKOUT_REPORT_EXCEL}?days=${data?.days
  //       }${data?.gender ? `&gender=${data?.gender}` : ""}${data?.mode ? `&mode=${data?.mode}` : ""
  //       }`,
  //       {
  //         baseURL: `${process.env.REACT_APP_API_URL}`,
  //         responseType: "blob",
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem(
  //             Constants.accessToken
  //           )}`,
  //         },
  //       }
  //     );
  //     setLoader(false);
  //     // Create a Blob from the data and generate a download link
  //     const url = window.URL.createObjectURL(new Blob([response.data]));
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", "Reports.xlsx");
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //   } catch (error) {
  //     setLoader(false);
  //     console.error("Error downloading the Excel file:", error);
  //   }
  // };

  const onExportExcel = () => {
    setLoader(true);
    const metrics = [
      { key: "workoutSessionSplit", value: workoutSessionSplit }
    ];
    // data to be written to the workbook.
    const dataForWorkBook = {};


    // convert the metrics array data to arrays of objects so that it can be written to the excel sheets.
    metrics.forEach(function (item, index) {
      const result = item.value.dates.map((day, i) => ({
        date: day,
        count: item.value.recordcounts[i],
        gender: selectedGender.label,
        mode: selectedMode.label
      }));

      dataForWorkBook[item.key] = result;
    });

    const workbook = XLSX.utils.book_new();
    // loop through the workbook data, create a sheet and append the sheet to workbook
    Object.keys(dataForWorkBook).forEach(function (item, index) {
      const worksheet = XLSX.utils.json_to_sheet(dataForWorkBook[item]);
      XLSX.utils.book_append_sheet(workbook, worksheet, item);
    });


    XLSX.writeFile(workbook, "workout-session-split-report.xlsx");
    setLoader(false);
  };

  return (
    <div className="container-xxl">
      <div className="catalog_box al_catalog_box mt-4">
        <div className=" row row_end order-list-view">
          <div className="col-md-2 filter-tabs">
            <ReactSelect
              label={Constants.gender}
              options={Constants.genderOptions}
              onChange={(e) => setSelectedGender(e)}
              value={selectedGender}
            />
          </div>
          <div className="col-md-2 filter-tabs">
            <ReactSelect
              label={Constants.mode}
              options={Constants.modeOptions}
              onChange={(e) => setSelectedMode(e)}
              value={selectedMode}
            />
          </div>
          {viewPermission && (
            <>
              {loader ? (
                <div className="col-md-1 filter-tabs">
                  <img src={Spinner} alt="spinner" width="40px" height="40px" />
                </div>
              ) : (
                <div className="col-md-1 filter-tabs">
                  <div className="btn-hover">
                    <button
                      onClick={() => {
                        onExportExcel();
                      }}
                      title=""
                      className="btn btn-primary text-uppercase"
                    >
                      <img
                        src={ExcelIcon}
                        alt="excel-icon"
                        className="img-excel"
                      />
                      {Constants.export}
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        {tabsList.length > 0 && (
          <TabsBootstrap
            defaultActiveKey={activetab}
            onSelect={(index) => {
              setActiveTab(index);
            }}
            activeKey={activetab}
            handleTabSelect={handleTabSelect}
            options={tabsList}
          />
        )}
      </div>
    </div>
  );
};

export default WorkoutSessionSplit;
